import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import RouteChangeLoader from "./components/RouteChangeLoader";

import Home from "./pages/home";
import HomeTwo from "./pages/home-2";
import Testimonials from "./pages/testimonials";
import Faq from "./pages/faq";
import NoPage from "./pages/NoPage";
import About from "./pages/about";
import ServicesCarousel from "./pages/services-carousel";
import Solutions from "./pages/express-freight-solutions";
import Logistics from "./pages/quick-move-logistics";
import Dispatch from "./pages/speedy-dispatch";
import Chain from "./pages/swift-supply-chain";
import Distribution from "./pages/on-point-distribution";
import Team from "./pages/team";
import TeamCarousel from "./pages/team-carousel";
import TeamDetails from "./pages/team-details";
import ProjectDetails from "./pages/project-details";
import Project from "./pages/project";
import BlogDetails from "./pages/blog-details";
import Blog from "./pages/blog";
import Contact from "./pages/contact";
import Principals from "./pages/principals";
import ScrollToTop from "./components/ScrollToTop";

function resolveBasename() {
  if (process.env.REACT_APP_BASENAME) {
    return process.env.REACT_APP_BASENAME;
  }

  if (process.env.PUBLIC_URL && process.env.PUBLIC_URL !== ".") {
    return process.env.PUBLIC_URL;
  }

  const script = document.querySelector('script[src*="/static/js/main"]');
  if (!script) return "";

  const src = script.src || script.getAttribute("src") || "";
  const path = (() => {
    try {
      return new URL(src, window.location.href).pathname;
    } catch {
      return src;
    }
  })();

  const staticIdx = path.indexOf("/static/");
  if (staticIdx === -1) return "";

  const base = path.slice(0, staticIdx).replace(/\/$/, "");
  if (!base || base === ".") return "";
  return base;
}

export default function App() {
  const basename = resolveBasename();

  return (
    <BrowserRouter basename={basename}>
      {/* 1) scroll to top on every navigation */}
      <ScrollToTop />

      {/* 2) loader on route change */}
      <RouteChangeLoader />

      <Routes>
        <Route index element={<Home />} />
        <Route path="*" element={<NoPage />} />
        <Route path="home-2" element={<HomeTwo />} />
        <Route path="services-carousel" element={<ServicesCarousel />} />
        <Route path="express-freight-solutions" element={<Solutions />} />
        <Route path="quick-move-logistics" element={<Logistics />} />
        <Route path="speedy-dispatch" element={<Dispatch />} />
        <Route path="swift-supply-chain" element={<Chain />} />
        <Route path="on-point-distribution" element={<Distribution />} />
        <Route path="faq" element={<Faq />} />
        <Route path="team-carousel" element={<TeamCarousel />} />
        <Route path="about" element={<About />} />
        <Route path="testimonials" element={<Testimonials />} />
        <Route path="team" element={<Team />} />
        <Route path="team-details" element={<TeamDetails />} />
        <Route path="principals" element={<Principals />} />
        <Route path="project-details" element={<ProjectDetails />} />
        <Route path="product-portfolio" element={<Project />} />
        <Route path="blog-details" element={<BlogDetails />} />
        <Route path="blog" element={<Blog />} />
        <Route path="contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}
